import { styled, Box } from "@mui/material";

export const Root = styled(Box)({
  zIndex: 1000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}) as typeof Box;

export const StyledWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
})) as typeof Box;
